import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import {
    BlobTypeStoreReadSettingsAdapter,
    blobTypeStoreReadSettingsAdapts
} from './blob-type-store-read-settings.adapter';
import { FtpStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/ftp-store-read-settings';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FtpStoreReadSettings),
    asynchronous: true,
    adapts: {
        useBinaryTransfer: '*',
        deleteFilesAfterCompletion: '*',
        disableChunking: '*',
        ...blobTypeStoreReadSettingsAdapts
    }
})
export class FtpStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<
    FtpStoreReadSettings,
    Model.StoreReadSettings
> {
    protected override async _toModel(
        resource: Model.StoreReadSettings,
        copySource: CopySource
    ): Promise<FtpStoreReadSettings> {
        const model = await super._toModel(resource, copySource);
        ValueAdapter.toModel(model, FtpStoreReadSettings.USE_BINARY_TRANSFER, resource.useBinaryTransfer);
        ValueAdapter.toModel(
            model,
            FtpStoreReadSettings.DELETE_FILE_AFTER_COMPLETION,
            resource.deleteFilesAfterCompletion
        );

        if (resource.disableChunking !== undefined) {
            ValueAdapter.toModel(model, FtpStoreReadSettings.DISABLE_CHUNKING, resource.disableChunking);
        } else {
            delete model.disableChunking;
        }

        return model;
    }

    protected override async _toResource(settings: FtpStoreReadSettings): Promise<Model.StoreReadSettings> {
        const resource = await super._toResource(settings);
        resource.useBinaryTransfer = ValueAdapter.toResource(settings, FtpStoreReadSettings.USE_BINARY_TRANSFER);
        resource.deleteFilesAfterCompletion = ValueAdapter.toResource(
            settings,
            FtpStoreReadSettings.DELETE_FILE_AFTER_COMPLETION
        );
        resource.disableChunking = ValueAdapter.toResource(settings, FtpStoreReadSettings.DISABLE_CHUNKING);
        return resource;
    }
}
